class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
          initMiniCartATL();
          initMiniCartGiftConfirm();
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;

    // While the drawer is open (upsell adds, gift wrap, quick view),
    // patch the money-touched regions instead of swapping the whole
    // drawer — keeps open collapsibles, scroll and upsell state intact.
    const drawerOpen = this.drawer && !!this.drawer.querySelector('details[open]');

    this.getSectionsToRender().forEach((section => {
      if (!document.getElementById(section.id)) return;

      if (
        section.id === 'mini-cart' &&
        drawerOpen &&
        window.theme && theme.patchMiniCart &&
        parsedState.sections[section.id] &&
        theme.patchMiniCart(this.getSectionInnerHTML(parsedState.sections[section.id], section.selector))
      ) return;

      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    this.open();
    initMiniCartATL();
    initMiniCartGiftConfirm();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);

// [ATL BLOCK - mini-cart] Authority to Leave — re-initialised after every re-render
function initMiniCartATL() {
  var atlBlock = document.getElementById('mini-cart-atl-block');
  var atlError = document.getElementById('mini-cart-atl-error');
  var atlHidden = document.getElementById('mini-cart-atl-attribute');

  // Guard: skip if already wired up on this exact DOM node
  if (!atlBlock || atlBlock._atlInit) return;
  atlBlock._atlInit = true;

  var radios = atlBlock.querySelectorAll('input[type="radio"]');
  var form = atlBlock.closest('form');
  var checkoutBtn = form && form.querySelector('button[name="checkout"]');

  function setSelectedState(radio) {
    atlBlock.querySelectorAll('.cart-permission__option').forEach(function (opt) {
      opt.classList.remove('cart-permission__option--selected');
    });
    radio.closest('.cart-permission__option').classList.add('cart-permission__option--selected');
  }

  radios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      var value = this.value;
      if (atlHidden) atlHidden.value = value;
      setSelectedState(this);
      if (atlError) atlError.classList.remove('is-visible');
      // Persist immediately so re-renders (quantity change etc.) keep the selection
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'authority-to-leave': value } })
      });
      // Broadcast so the full cart page syncs in real time if visible
      document.dispatchEvent(new CustomEvent('atl:changed', { detail: { value: value, source: 'mini-cart' } }));
    });
  });

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      var selected = atlBlock.querySelector('input[type="radio"]:checked');
      if (!selected) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (atlError) atlError.classList.add('is-visible');
        atlBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
  }
}

// Quantity changes in cart.js patch #mini-cart-atl-block's ancestor
// (cart-items) or fully re-render the drawer without going through the
// MiniCart class methods above — 'cart:updated' fires after both, so it's
// the one signal common to every code path that can replace this block.
document.addEventListener('cart:updated', initMiniCartATL);

document.addEventListener('atl:changed', function (e) {
  if (e.detail.source === 'mini-cart') return;
  var atlBlock = document.getElementById('mini-cart-atl-block');
  if (!atlBlock) return;
  var atlHidden = document.getElementById('mini-cart-atl-attribute');
  var atlError = document.getElementById('mini-cart-atl-error');
  atlBlock.querySelectorAll('input[type="radio"]').forEach(function (radio) {
    if (radio.value === e.detail.value) {
      radio.checked = true;
      atlBlock.querySelectorAll('.cart-permission__option').forEach(function (opt) {
        opt.classList.remove('cart-permission__option--selected');
      });
      radio.closest('.cart-permission__option').classList.add('cart-permission__option--selected');
      if (atlError) atlError.classList.remove('is-visible');
    }
  });
  if (atlHidden) atlHidden.value = e.detail.value;
});
// [/ATL BLOCK - mini-cart]

// [GIFT CONFIRM BLOCK - mini-cart] Checkout-time nudge if no gift message
// was added — not a hard block like ATL, just a "did you mean to skip this?"
// prompt. Registered after initMiniCartATL() in every re-init hook, so on an
// actual click ATL's listener (if it blocks) runs first via
// stopImmediatePropagation and this one never fires — ATL still takes
// priority over this softer nudge.
function initMiniCartGiftConfirm() {
  var confirmBox = document.getElementById('mini-cart-gift-confirm');
  if (!confirmBox || confirmBox._giftConfirmInit) return;
  confirmBox._giftConfirmInit = true;

  var backdrop = document.getElementById('mini-cart-gift-confirm-backdrop');
  var form = confirmBox.closest('form');
  var checkoutBtn = form && form.querySelector('button[name="checkout"]');
  var continueBtn = document.getElementById('mini-cart-gift-confirm-continue');
  var addBtn = document.getElementById('mini-cart-gift-confirm-add');
  var closeBtn = document.getElementById('mini-cart-gift-confirm-close');
  var giftDetails = document.getElementById('mini-cart-gift-message');
  var dismissed = false;

  function giftFieldsBlank() {
    var to = document.getElementById('mini-cart-gift-to');
    var from = document.getElementById('mini-cart-gift-from');
    var note = document.getElementById('mini-cart-gift-note');
    return !(to && to.value.trim()) && !(from && from.value.trim()) && !(note && note.value.trim());
  }

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      if (!dismissed && giftFieldsBlank()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        confirmBox.hidden = false;
        if (backdrop) backdrop.hidden = false;
        confirmBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
  }

  if (continueBtn) {
    continueBtn.addEventListener('click', function () {
      dismissed = true;
      confirmBox.hidden = true;
      if (backdrop) backdrop.hidden = true;
      // requestSubmit (not a synthetic click) so this doesn't re-trigger
      // the click-intercept above, and other submit listeners still run.
      if (form && checkoutBtn) form.requestSubmit(checkoutBtn);
    });
  }

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      confirmBox.hidden = true;
      if (backdrop) backdrop.hidden = true;
      if (giftDetails) {
        giftDetails.open = true;
        giftDetails.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  // Just closes — doesn't count as "continue" (checkout stays blocked, the
  // prompt shows again next Checkout click) or open the message popup.
  function dismiss() {
    confirmBox.hidden = true;
    if (backdrop) backdrop.hidden = true;
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', dismiss);
  }

  if (backdrop) {
    backdrop.addEventListener('click', dismiss);
  }
}
document.addEventListener('cart:updated', initMiniCartGiftConfirm);
// [/GIFT CONFIRM BLOCK - mini-cart]
